import React, { useState, useEffect } from "react";

import styles from "./index.module.css";
import ReportTableAllAttendees from "Reporting/Components/ReportTableAllAttendees";
import { useAllAttendeesGet } from "./useAllAttendeesGet";
import Loader from "shared/Loader";

export default function ReportTableListAllAttendees({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const [reports, setReports] = useState([]);
  const [sortedReportsByTitle, setSortedReportsByTitle] = useState({});

  const { data, isLoading, isError, refetch } = useAllAttendeesGet({
    events: filters.events,
  });

  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger]);

  useEffect(() => {
    if (data) {
      const uniqueTitles = Array.from(
        new Set(data.flatMap((item) => item.reportTitle || []))
      );

      const groupedReports = uniqueTitles.map((title) => ({
        title,
        reports: data.filter((item) =>
          (item.reportTitle || []).includes(title)
        ),
      }));

      setReports(groupedReports);

      setSortedReportsByTitle(() => {
        const updated = {};
        groupedReports.forEach((r) => {
          updated[r.title] = r.reports;
        });
        return updated;
      });

      setReportsLength?.(groupedReports.length || 0);
    }
  }, [data, setReportsLength]);

  const handleSortedReportsChange = (title, sorted) => {
    setSortedReportsByTitle((prev) => ({ ...prev, [title]: sorted }));
  };

  useEffect(() => {
    if (reports.length === 0) return;
    const merged = reports.map((r) => ({
      ...r,
      reports: sortedReportsByTitle[r.title]
        ? sortedReportsByTitle[r.title]
        : r.reports,
    }));
    setReportData?.(merged);
  }, [sortedReportsByTitle, reports, setReportData]);

  if (isError) {
    return <div>Something went wrong...</div>;
  }
  if (isLoading) {
    return <Loader />;
  }
  if (reports.length === 0) {
    return <div>No Reports Found</div>;
  }

  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <React.Fragment key={index}>
          <ReportTableAllAttendees
            reports={report.reports}
            title={report.title}
            onSortedReportsChange={handleSortedReportsChange}
          />
        </React.Fragment>
      ))}
    </div>
  );
}
